import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import CoordinatingGroupConfigurationList from "@/components/lists/status/CoordinatingGroupConfigurationList";
import CoordinatingGroupsContext from "@/contexts/data/CoordinatingGroupsContext";
import { ConfigurationCoordinatingGroupsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";



const ConfigurationCoordinatingGroups: FC = () => {
    const { data: coordinatingGroups } = useContext(CoordinatingGroupsContext);

    const loading = false;
    const validating = false;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationCoordinatingGroupsTrialCreateLink} 
                institutionLinkEnabled={false} 
                participantLinkEnabled={false} 
            />
            <IsLoading name="configuration-coordinating-groups-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; CoordinatingGroups
                </Typography>
                <CoordinatingGroupConfigurationList 
                    data={coordinatingGroups}
                />
            </Show>
        </>
    )
};

export default ConfigurationCoordinatingGroups;